import _ from 'lodash'

import { ParamsKind } from 'features/globalSetup/pages/Prebid/Bidders/types'
import { AdUnitParameter, AdUnitParameters } from 'features/globalSetup/types/adUnitBidder'
import {
  Schema,
  SchemaAdUnitBidderParamValidation,
  SchemaAdUnitBidderProps,
} from '../../form/schema'
import { AdUnitBidderSlice } from '../../hooks/UseGetAdUnitBidders'

export const adUnitBiddersToSchema = (
  adUnitBidders: AdUnitBidderSlice[],
): Schema['adUnitBidders'] =>
  _.chain(adUnitBidders)
    .keyBy('id')
    .mapValues((adUnitBidder: AdUnitBidderSlice) => {
      const { csEnabled, csParams, s2sEnabled, s2sParams } = adUnitBidder

      return {
        _paramsValidation: [
          ...paramsToSchemaValidation(csParams, 'cs'),
          ...paramsToSchemaValidation(s2sParams, 's2s'),
        ],
        csDisabledByRequiredParams: false,
        csEnabled,
        csParams: _.mapValues(csParams, 'value'),
        s2sDisabledByRequiredParams: false,
        s2sEnabled,
        s2sParams: _.mapValues(s2sParams, 'value'),
      }
    })
    .value()

const paramsToSchemaValidation = (
  params: AdUnitParameters,
  kind: ParamsKind,
): SchemaAdUnitBidderProps['_paramsValidation'] =>
  Object.entries(params).map(
    ([, value]: [
      key: keyof AdUnitParameters,
      value: AdUnitParameter,
    ]): SchemaAdUnitBidderParamValidation => ({
      kind,
      name: value.name,
      required: value.required ?? false,
      requiredOff: value.requiredOff,
      type: value.type,
    }),
  )

export const getRequiredParams = (paramsSchema: AdUnitParameters): AdUnitParameters =>
  Object.fromEntries(
    Object.entries(paramsSchema).filter(
      ([, { required, requiredOff }]: [key: keyof AdUnitParameters, value: AdUnitParameter]):
        | boolean
        | undefined => (requiredOff ? false : required),
    ),
  )

export const getRequiredParamsNames = (params: AdUnitParameters): AdUnitParameter['name'][] =>
  Object.entries(params).map(
    ([key]: [key: keyof AdUnitParameters, value: AdUnitParameter]): AdUnitParameter['name'] => key,
  )
